/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import { ListItemIcon, ListItemText, MenuItem, MenuList, Popover, Typography } from '@mui/material';
import Check from '@mui/icons-material/esm/Check';
import { graphManager } from '../../GraphManager';

const checkItem = (item) => (
	<React.Fragment>
		<ListItemIcon>
			<Check />
		</ListItemIcon>
		{item}
	</React.Fragment>
);
const getListItem = (sheet, checked) => {
	const color = sheet.isVisible ? 'text.primary' : 'text.disabled';
	const item = (
		<ListItemText inset={!checked}>
			<Typography color={color}>{sheet.name}</Typography>
		</ListItemText>
	);
	return checked ? checkItem(item) : item;
};

export default function SheetTabsList(props) {
	const tabContainer = props.tabContainer;
	const streamsheets = tabContainer ? tabContainer.getStreamSheetsContainer().streamSheetsModel : [];

	const handleClick = (sheet, index) => {
		graphManager.showSheet(sheet);
		props.selectTab(index, tabContainer);
		props.onClose();
	};

	return (
		<Popover
			open={props.open}
			anchorEl={props.anchorEl}
			anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
			transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
			onClose={props.onClose}
		>
			<MenuList>
				{streamsheets.map((sheet, index) => (
					<MenuItem key={sheet.id} onClick={() => handleClick(sheet, index)}>
						{getListItem(sheet, tabContainer.activeSheetIndex === index)}
					</MenuItem>
				))}
			</MenuList>
		</Popover>
	);
}
